// Set while a video upload modal is alive so a frontend deploy does not
// reload the page under it (see the Version check in api/index.ts).
let locked = false;

export const setUploadLock = (value: boolean) => {
  locked = value;
};

export const isUploadLocked = () => locked;
